/**
 * Heritage V2 header — flyout positioning for single-line desktop nav.
 * Sets fixed dropdown top/left so flyouts are not clipped by scroll/flex containers.
 * Uses vv-dropdown-open + hover intent so fixed flyouts stay reachable (Wines, Food, etc.).
 */
(function () {
  var DESKTOP_MIN = 1024;
  var CLOSE_DELAY = 200;
  var resizeTimer;

  function isDesktopNav() {
    return window.innerWidth >= DESKTOP_MIN;
  }

  function headerBar() {
    return (
      document.querySelector('.section-header__main-bar') ||
      document.querySelector('.js-theme-header')
    );
  }

  function getFlyout(menuItem) {
    return menuItem.querySelector('.dropdown:not(.dropdown--nested), .megamenu');
  }

  function updateDropdownTop() {
    if (!isDesktopNav()) {
      document.documentElement.style.removeProperty('--vv-header-dropdown-top');
      closeAllDropdowns();
      return;
    }

    var bar = headerBar();
    if (!bar) {
      return;
    }

    document.documentElement.style.setProperty(
      '--vv-header-dropdown-top',
      bar.getBoundingClientRect().bottom + 'px'
    );
  }

  function positionDropdown(menuItem) {
    if (!isDesktopNav() || !menuItem) {
      return;
    }

    var dropdown = getFlyout(menuItem);
    if (!dropdown) {
      return;
    }

    var link = menuItem.querySelector('.navigation__menulink, .js-menu-link');
    if (!link) {
      return;
    }

    var linkRect = link.getBoundingClientRect();
    menuItem.style.setProperty('--vv-dropdown-left', linkRect.left + 'px');
  }

  function clearDropdownPosition(menuItem) {
    if (!menuItem) {
      return;
    }

    menuItem.style.removeProperty('--vv-dropdown-left');
  }

  function cancelClose(menuItem) {
    if (menuItem._vvCloseTimer) {
      clearTimeout(menuItem._vvCloseTimer);
      menuItem._vvCloseTimer = null;
    }
  }

  function openDropdown(menuItem) {
    if (!isDesktopNav() || !menuItem) {
      return;
    }

    document
      .querySelectorAll('.section-header .navigation__menuitem--dropdown.vv-dropdown-open')
      .forEach(function (other) {
        if (other !== menuItem) {
          closeDropdown(other);
        }
      });

    cancelClose(menuItem);
    positionDropdown(menuItem);
    menuItem.classList.add('vv-dropdown-open');
  }

  function closeDropdown(menuItem) {
    if (!menuItem) {
      return;
    }

    cancelClose(menuItem);
    menuItem.classList.remove('vv-dropdown-open');
    clearDropdownPosition(menuItem);
  }

  function scheduleClose(menuItem) {
    if (!isDesktopNav() || !menuItem) {
      return;
    }

    cancelClose(menuItem);
    menuItem._vvCloseTimer = setTimeout(function () {
      menuItem._vvCloseTimer = null;
      closeDropdown(menuItem);
    }, CLOSE_DELAY);
  }

  function closeAllDropdowns() {
    document.querySelectorAll('.section-header .navigation__menuitem--dropdown.vv-dropdown-open').forEach(function (item) {
      closeDropdown(item);
    });
  }

  function positionOpenDropdowns() {
    document
      .querySelectorAll(
        '.section-header .navigation__menuitem--dropdown.vv-dropdown-open, .section-header .navigation__menuitem--dropdown:hover'
      )
      .forEach(positionDropdown);
  }

  function bindDropdownItems() {
    document.querySelectorAll('.section-header .navigation__menuitem--dropdown').forEach(function (item) {
      if (item.dataset.vvDropdownBound === 'true') {
        return;
      }

      var flyout = getFlyout(item);
      if (!flyout) {
        return;
      }

      item.dataset.vvDropdownBound = 'true';

      function onPointerEnter() {
        openDropdown(item);
      }

      function onPointerLeave() {
        scheduleClose(item);
      }

      item.addEventListener('mouseenter', onPointerEnter);
      item.addEventListener('mouseleave', onPointerLeave);
      item.addEventListener('focusin', onPointerEnter);

      flyout.addEventListener('mouseenter', onPointerEnter);
      flyout.addEventListener('mouseleave', onPointerLeave);

      item.addEventListener('focusout', function (event) {
        if (!item.contains(event.relatedTarget)) {
          scheduleClose(item);
        }
      });
    });
  }

  function debouncedUpdate() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      updateDropdownTop();
      bindDropdownItems();
      positionOpenDropdowns();
    }, 100);
  }

  function bindNavScroll() {
    var navMenu = document.querySelector('.section-header .navigation__menu');
    if (!navMenu || navMenu.dataset.vvNavScrollBound === 'true') {
      return;
    }

    navMenu.dataset.vvNavScrollBound = 'true';
    navMenu.addEventListener('scroll', function () {
      updateDropdownTop();
      positionOpenDropdowns();
    }, { passive: true });
  }

  function init() {
    updateDropdownTop();
    bindDropdownItems();
    bindNavScroll();
  }

  function runInit() {
    init();
    positionOpenDropdowns();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runInit);
  } else {
    runInit();
  }

  window.addEventListener('load', function () {
    updateDropdownTop();
    positionOpenDropdowns();
  });
  window.addEventListener('resize', debouncedUpdate);
  window.addEventListener('scroll', function () {
    updateDropdownTop();
    positionOpenDropdowns();
  }, { passive: true });
  document.addEventListener('shopify:section:load', debouncedUpdate);
})();
